import { statBar } from '@/mocks/homeData';

export default function StatStrip() {
  return (
    <section className="w-full border-b border-background-200 bg-secondary-950">
      <div className="mx-auto grid max-w-[1440px] grid-cols-2 divide-background-50/10 px-4 md:grid-cols-4 md:divide-x md:px-8">
        {statBar.map((item, idx) => (
          <div
            key={item.label}
            className={`px-2 py-5 md:px-6 md:py-6 ${
              idx < 2 ? 'border-b border-background-50/10 md:border-b-0' : ''
            } ${idx % 2 === 0 ? 'border-r border-background-50/10 md:border-r-0' : ''}`}
          >
            <p className="font-heading text-2xl font-black text-background-50 md:text-3xl">{item.value}</p>
            <p className="mt-1 font-label text-xs text-background-50/70 md:text-sm">{item.label}</p>
            <p className="mt-1.5 font-label text-[11px] text-accent-300">{item.note}</p>
          </div>
        ))}
      </div>
    </section>
  );
}